"use client"

import { ReactNode } from "react"

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"

interface ModalProps {
  title: string
  description: string
  open: boolean
  onClose: () => void
  children?: ReactNode
  isShowRejectBTN?: boolean
}

export function Modal({
  title,
  description,
  open,
  onClose,
  children,
  isShowRejectBTN,
}: ModalProps) {
  const onChange = (open: boolean) => {
    if (!open) {
      onClose()
    }
  }

  return (
    <AlertDialog open={open} onOpenChange={onChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <div>{children}</div>
        {isShowRejectBTN && (
          <AlertDialogFooter>
            <div className="flex justify-end">
              <AlertDialogAction>Close</AlertDialogAction>
            </div>
          </AlertDialogFooter>
        )}
      </AlertDialogContent>
    </AlertDialog>
  )
}
